/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prefix: NonNullable<unknown> }} Integrations_Apis_Badge_Path_ScopeInputs */



/**
* | output |
* | --- |
* | "Only {prefix}" |
*
* @param {Integrations_Apis_Badge_Path_ScopeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_badge_path_scope = /** @type {((inputs: Integrations_Apis_Badge_Path_ScopeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Badge_Path_ScopeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nur ${i?.prefix}`)
	return /** @type {LocalizedString} */ (`Only ${i?.prefix}`)
});